export default "/_next/static/images/f4bb459e4bfcda2cf70f0b98dbfdd04e.png";